import React, { Component } from 'react';

import { Chart } from 'react-google-charts';

export class DashboardChart extends Component {

    isDataPresent = () => {
      if (this.props.routesList.filter((route) => {
        return route.selected;
      }).length > 0) {return true} else {return false}
    }

    getCols = () => {
      var cols = [];
      cols.push({label: 'Id', type: 'string'})
      this.props.routesList.filter((route) => {
           return route.selected;
         }).map((route, index) => {
           cols.push({label:route.from.name + " - " +route.to.name, type:'number'}) ;
           return null;
         });
      return cols;
    }

    getChartData = () => {
      var chartData = [];
      chartData.push('Drive');

      this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        //chartData.push(Math.floor(Math.random() * (10 - 1 + 1)) + 1);
        chartData.push(route.endDate.getHours()-route.startDate.getHours());
        return null;
      });

      return [chartData];
    }

    getChartColors = () => {
      return this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        return '' + route.pathColor;
      })

    }


    render() {
      return (
        <Chart
          chartType="ComboChart"
          data={[
         ['Month', ' ​< 7 Days', '7 - 14 days', '15 - 30 days', '30 days'],
         ['January',  .20,      .225,         .45,             .24],
         ['February',  .56,      .33,        .45,             .20],
         ['March',  .35,      .23,        .28,             .34],
         ['April',  .24,      .11,        .36,             .55],
         ['May',  .60,      .45,         .23,             .35],
         ['June',  .27,      .53,         .49,             .24],
         ['July',  .12,      .23,         .34,             .56],
         ['August',  .25,      .36,        .14,             .62],
         ['September',  .14,      .37,        .34,             .23],
         ['October',  .24,      .32,         .65,             .34],
         ['November',  .24,      .34,         .43,             .42],
         ['December',  .62,      .52,         .53,             .32]
      ]}
          options={{
              legend: { position: 'right',
                        textStyle: {
                          fontSize: 10
                        }
                      },
              bar: { groupWidth: '65%' },
              vAxis: {
                format: 'percent',
                textStyle: {
                  fontSize: 10
                }
              },
              hAxis: {
                textStyle: {
                  fontSize: 10
                }
              }

            }}
          graph_id="DashboardChart"
          width="100%"
          height="200px"

        />
      );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/DashboardChart.js